/// <amd-module name="SuiteCommerce.LookBook.PDP"/>
define("SuiteCommerce.LookBook.PDP", ["require", "exports", "SuiteCommerce.LookBook.LookItem.Collection", "SuiteCommerce.LookBook.PDP.LookItem.CollectionView"], function (require, exports, LookItem_Collection_1, PDP_LookItem_CollectionView_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var pdp = container.getComponent('PDP');
            if (pdp) {
                this.addPdpChildView(container, pdp);
            }
        },
        addPdpChildView: function (container, pdp) {
            pdp.addChildViews(pdp.PDP_FULL_VIEW, {
                'ProductReviews.Center': {
                    'ProductDetails.LookItems': {
                        childViewIndex: 20,
                        childViewConstructor: function () {
                            var itemInfo = pdp.getItemInfo().item;
                            var collection = new LookItem_Collection_1.LookItemCollection();
                            var collectionView = new PDP_LookItem_CollectionView_1.PDPLookItemCollectionView({
                                collection: collection,
                                itemId: itemInfo.itemid,
                            });
                            collection
                                .fetch({
                                data: {
                                    itemID: itemInfo.internalid,
                                },
                            })
                                .done(function () {
                                collectionView.render();
                                collectionView.setupCarousel();
                                collectionView.logUsageOfLookInPDP();
                            });
                            return collectionView;
                        },
                    },
                },
            });
        },
    };
});
